export default "__VITE_ASSET__dHKiRy_S__"